import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../../app/api/apiSlice'

const userImprintEtsAdapter = createEntityAdapter({})

const initialState = userImprintEtsAdapter.getInitialState()

export const userImprintEtsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserImprintEts: builder.query({
            query: () => ({
                url: '/userImprintEts/getUserImprintEts',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserImprintEts = responseData.map(userImprintEt => {
                    userImprintEt.id = userImprintEt._id
                    return userImprintEt
                })
                return userImprintEtsAdapter.setAll(initialState, loadedUserImprintEts)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserImprintEt', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserImprintEt', id}))
                    ]
                } else {
                    return [ { type: 'UserImprintEt', id: 'LIST'}]
                }
            },
        }),
        createNewUserImprintEt: builder.mutation({
            query: initialUserImprintEt => ({
                url: '/userImprintEts/createNewUserImprintEt',
                method: 'POST',
                body: {...initialUserImprintEt,}
            }),
            invalidatesTags: [
                { type: 'UserImprintEt', id: "LIST" }
            ] 
        }),
        updateUserImprintEt: builder.mutation({
            query: initialUserImprintEt => ({
                url: '/userImprintEts/updateUserImprintEt',
                method: 'PATCH',
                body: {...initialUserImprintEt,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserImprintEt', id: arg.id },
                { type: 'UserImprintEt', id: 'LIST' }
            ],
        }),
        deleteUserImprintEt: builder.mutation({
            query: ({id}) => ({
                url: '/userImprintEts/deleteUserImprintEt',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserImprintEt', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserImprintEtsQuery,
    useCreateNewUserImprintEtMutation,
    useUpdateUserImprintEtMutation,
    useDeleteUserImprintEtMutation,
} = userImprintEtsApiSlice

// returns the query result object
export const selectUserImprintEtResult = userImprintEtsApiSlice.endpoints.getUserImprintEts.select()

// create memoized selector
const selectUserImprintEtsData = createSelector(
    selectUserImprintEtResult,
    userImprintEtResult => userImprintEtResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserImprintEts,
    selectById: selectUserImprintEtById,
    selectIds: selectUserImprintEtIds,
} = userImprintEtsAdapter.getSelectors(state => selectUserImprintEtsData(state) ?? initialState)